import deepmerge from 'deepmerge'
import store from '../../store/store'

/**
 * Chat state object
 *  * `unknown` - not initialised
 *  * `ready` - e.g. initialised
 *  * `init` - initialisation started, incomplete
 */
const state = {
  unknown: null,
  ready: 'ready',
  init: 'initalising'
}



/**
 * Define name space `Chat`
 * Initial plugin state and actions
 */
const Chat = {
  liveChat: {
    config: {},
    state: state.unknown
  },
  pendingActions: []
}

/**
 * Vue Chat Plugin - global namespace methods
 *
 *  this.$initialiseChat,
 *  this.$liveChatStart,
 *
 * and Throws Errors when things go wrong!
 */

/**
 *
 * @param {*} config
 */
const actionPending = () => {
  const action = Chat.pendingActions && Chat.pendingActions.pop()
  if (action) {
    Chat.pendingActions = []
    if (typeof action === 'function') {
      action()
    }
  }
}


/**
 * Creates a new instance of Live Chat
 * @param {Object} config for example:
 {
    liveChat: {
      "url": <String>,
      "department": <Sting>,
      "tags": <Array>
    }
  },
 */
const initialiseChat = () => {
  // Common instantiation
  const init = () => {
    window.jeLiveChat.init(Chat.liveChat.config)
    Chat.liveChat.state = state.ready
    // exec pending actions
    actionPending()
  }

  // Instantiate once
  if (Chat.liveChat.state === state.unknown) {
    Chat.liveChat.state = state.init
    // Already loaded
    if (window.jeLiveChat) {
      init()
    } else {
      // Load Live Chat library
      import(/* webpackChunkName: "jeLiveChat" */ '@justeat/live-chat')
        .then(() => {
          init()
        })
        .catch(e => {
          // Failed to load
          Chat.liveChat.state = state.unknown
          store.dispatch('disableLiveChat', e)
        })
    }
  } else {
    // Chats ready, follow up with pending actions
    actionPending()
  }
}

/**
 * Starts a new Live Chat
 * @param {Object} chatData Optional values for example:
 * {
 *  department: <String>,
 *  message: <String>,
 *  tags: <Array>
 * }
 */
const liveChatStart = (chatData = {}) => {
  if (Chat.liveChat.state !== state.ready) {
    Chat.pendingActions.push(liveChatStart)
    initialiseChat()
  } else {
    try {
      const data = { ...chatData }
      if (window.jeLiveChat) {
        window.jeLiveChat.start(data)
      }
    } catch (e) {
      throw new Error(`
        Ref.: liveChatStart
        ${e.stack}
        `)
    }
  }
}

/**
 * Updates Live Chat configuration
 * @param {Object} configuration Configuration object
 */
const updateChatConfig = configuration => {
  if (configuration.liveChat) {
    Chat.liveChat.config = deepmerge(
      Chat.liveChat.config,
      configuration.liveChat
    )
  }
}

Chat.install = (Vue, config) => {
  if (config) {
    updateChatConfig(config)
  }

  Vue.prototype.$initialiseChat = configuration => {
    updateChatConfig(configuration)
    initialiseChat()
  }

  Vue.prototype.$startLiveChat = chatData => {
    liveChatStart(chatData)
  }
}

export default Chat
